import React from "react";
import { FREE_TRIAL_APPLICATION_CREDITS } from "@src/config/freeTrial";
import SeoCtaLink from "@components/SeoCtaLink";

const CallToAction = () => {
  return (
    <div className="w-full px-4 py-8 md:px-8 lg:px-12 md:py-20">
      <div className="relative mx-auto max-w-[900px] overflow-hidden rounded-[2.5rem] bg-gradient-to-br from-[#5B36B1] via-[#6B46C1] to-[#9F7AEA] shadow-2xl ring-1 ring-white/20">
        
        {/* Background Texture - Grid Pattern */}
        <div 
          className="absolute inset-0 opacity-[0.25]"
          style={{
            backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
            backgroundSize: '32px 32px'
          }}
        ></div>

        {/* Decorative background blobs */}
        <div className="absolute top-0 left-0 -ml-20 -mt-20 h-[30rem] w-[30rem] rounded-full bg-purple-500 blur-3xl opacity-50 mix-blend-overlay"></div>
        <div className="absolute bottom-0 right-0 -mr-20 -mb-20 h-[30rem] w-[30rem] rounded-full bg-indigo-500 blur-3xl opacity-50 mix-blend-overlay"></div>

        {/* Floating "Glass" Cards - Visualizing the AI working - REMOVED per feedback */}

        {/* Main Content */}
        <div className="relative z-10 mx-auto flex max-w-3xl flex-col items-center px-6 py-16 text-center md:py-24">

          <h2 className="mb-6 text-3xl font-extrabold leading-tight tracking-tight text-white md:text-5xl lg:text-6xl drop-shadow-sm">
            Unlock Your Career Potential
          </h2>
          
          <p className="mb-10 max-w-2xl text-lg text-purple-50 md:text-xl leading-relaxed font-light opacity-90">
            See whether AI-assisted applications can reduce repetitive work and support a more consistent search.
          </p>

          <div className="flex flex-col items-center gap-4">
            <SeoCtaLink
              href="/signup/?utm_source=website&utm_medium=organic&utm_campaign=homepage&utm_content=bottom-cta"
              pageType="home"
              placement="bottom_cta"
              className="group relative inline-flex items-center justify-center overflow-hidden rounded-full bg-black px-10 py-5 font-bold text-white transition-all duration-300 hover:bg-gray-900 hover:scale-105 hover:shadow-[0_0_40px_-10px_rgba(255,255,255,0.3)] focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-purple-600"
            >
              {/* Button text explicitly white */}
              <span className="mr-2 text-lg text-white group-hover:text-white" style={{ color: 'white' }}>Get Started for Free</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="h-5 w-5 text-white transition-transform duration-300 group-hover:translate-x-1 group-hover:text-white">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
              
              {/* Subtle shimmer effect on button */}
              <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-1000 ease-out group-hover:translate-x-full"></div>
            </SeoCtaLink>
            
            <p className="!text-[10px] font-semibold text-purple-200/60 uppercase tracking-[0.2em]">
              {`${FREE_TRIAL_APPLICATION_CREDITS} application credits included - no credit card required`}
            </p>
          </div>

        </div>
      </div>
      
      {/* CSS Animation Keyframes (Inline to ensure it works without global CSS changes) */}
      <style>{`
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-15px); }
          100% { transform: translateY(0px); }
        }
        @keyframes shimmer {
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
};

export default CallToAction;
